import { render } from "./ProjectForm.vue?vue&type=template&id=10b841b7&scoped=true"
import script from "./ProjectForm.vue?vue&type=script&lang=js"
export * from "./ProjectForm.vue?vue&type=script&lang=js"

import "./ProjectForm.vue?vue&type=style&index=0&id=10b841b7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-10b841b7"

export default script